import {Component, ElementRef, OnDestroy, OnInit} from "@angular/core";
import {BrowserWindowService} from "../../shared-library/services/environment/browser-window.service";
import {ExternalConfigurationService} from "../../shared-library/services/configuration/external-configuration.service";
import {SearchParametersFactoryService} from "./services/search-parameters-factory.service";

@Component({
    selector: AdvancedSearchComponent.SELECTOR,
    templateUrl: "./advanced-search.component.html"
})
export class AdvancedSearchComponent implements OnInit, OnDestroy {
    public static SELECTOR: string = "pcg-ng-advanced-search";
    protected activeSearchTab: string;
    protected searchContext: string;

    public constructor(
        private _browserWindowService: BrowserWindowService,
        private _searchParametersFactory: SearchParametersFactoryService,
        private _configurationService: ExternalConfigurationService<{ context: string }>,
        private _domElement: ElementRef
    ) {
    }

    public ngOnInit(): void {
        this._configurationService.initialize(this._domElement);
        this.searchContext = this._configurationService.config?.context;

        const initialParameters = this._searchParametersFactory.createFromQueryString(this._browserWindowService.getQueryString());
        this.activeSearchTab = initialParameters.searchTab;
    }

    public ngOnDestroy(): void {
    }

    public switchSearchTab(tab: string): void {
        this.activeSearchTab = tab;
    }
}
